module.exports = __webpack_public_path__ + "static/media/lake.39ecb782.mp3";